import { FollowUpItem, IssueItem, PersonItem } from 'domain/shared/core/dashboard';
import { getProjectManager } from 'domain/shared/newProject';
import { StaffingDataType } from 'domain/shared/staffing';

export const staffingDataGetters = {
  followUps: (project: StaffingDataType): FollowUpItem[] => {
    const followUps: FollowUpItem[] = [];

    if (project.staffingRisk?.followUps) {
      project.staffingRisk.followUps.forEach(followUp => {
        followUps.push({
          id: followUp.id!,
          description: followUp.description,
          date: followUp.followUpDate,
          title: followUp.status,
          status: followUp.status,
        });
      });
    }
    return followUps;
  },

  issues: (project: StaffingDataType): IssueItem[] => {
    const issues: IssueItem[] = [];

    if (project.staffingRisk?.issues) {
      project.staffingRisk.issues.forEach(issue => {
        const severityMap: Record<string, 'low' | 'medium' | 'critical'> = {
          SAFE: 'low',
          MONITORING: 'medium',
          CRITICAL: 'critical',
        };

        const issueStatusMap: Record<string, 'open' | 'closed'> = {
          ACTIVE: 'open',
          CLOSED: 'closed',
        };

        issues.push({
          id: issue.id,
          title: issue.description,
          description: issue.description,
          severity: severityMap[issue.targetPriority],
          status: issueStatusMap[issue.status],
          createdAt: issue.createdAt,
        });
      });
    }

    return issues;
  },

  people: (project: StaffingDataType): PersonItem[] => {
    const people: PersonItem[] = [];
    const projectManager = getProjectManager(project);

    if (projectManager) {
      people.push({
        id: projectManager,
        name: projectManager,
        role: 'Project Manager',
      });
    }
    if (project.accountData?.ownerAlias) {
      people.push({
        id: project.accountData.ownerAlias,
        name: project.accountData.ownerAlias,
        role: 'Account manager',
      });
    }
    if (project.staffingCoordinator) {
      people.push({
        id: project.staffingCoordinator,
        name: project.staffingCoordinator,
        role: 'Staffing Coordinator',
      });
    }

    return people;
  },

  staffingRisk: (project: StaffingDataType) => {
    const staffingRisk = project.staffingRisk;

    if (!staffingRisk) {
      return {
        id: null,
        projectId: project.id,
        priority: undefined,
        issues: [],
        followUps: [],
        createdAt: new Date().toISOString(),
        updatedAt: null,
      };
    }

    return {
      id: staffingRisk.id,
      projectId: staffingRisk.projectId,
      priority: staffingRisk.priority,
      issues: staffingRisk.issues || [],
      followUps: staffingRisk.followUps || [],
      createdAt: staffingRisk.createdAt,
      updatedAt: staffingRisk.updatedAt,
    };
  },
};
